import { useEditor, useNode } from "@craftjs/core";
import * as React from "react";
import { useTranslation } from "react-i18next";

import { useDuplicateNode } from "@/components/editor/utils/use-duplicate-node";
import { CopySharp } from "@/components/icons/copy-sharp";
import { MovePage } from "@/components/icons/move-page";
import { TrashFilled } from "@/components/icons/trash-filled";

import {
  BlockOutlineFloatingOptionButton,
  BlockOutlineFloatingOptionsWrapper,
} from "../block-outline-component-styles";

export default function PrimitivesFloatingOptions() {
  const { t } = useTranslation();
  const {
    nodeId,
    connectors: { drag },
    deletable,
    moveable,
  } = useNode((node) => {
    return {
      nodeId: node.id,
      deletable: node.isDeletable(),
      moveable: node.isDraggable(),
    };
  });

  const {
    actions: { delete: deleteNode },
  } = useEditor();

  const { duplicate } = useDuplicateNode();

  return (
    <BlockOutlineFloatingOptionsWrapper>
      {moveable && (
        <BlockOutlineFloatingOptionButton
          ref={drag}
          data-testid="block-outline-move-page"
        >
          <MovePage className="inline size-5 text-white" />
        </BlockOutlineFloatingOptionButton>
      )}

      {deletable && (
        <BlockOutlineFloatingOptionButton
          data-testid="block-outline-delete-outlined"
          aria-label={t("common.delete")}
          onClick={() => deleteNode(nodeId)}
        >
          <TrashFilled className="inline size-5 text-white" />
        </BlockOutlineFloatingOptionButton>
      )}

      {moveable && (
        // If its moveable, it must be in a list so it's also duplicable.
        <BlockOutlineFloatingOptionButton
          data-testid="block-outline-copy"
          aria-label={t("common.copy")}
          onClick={() => duplicate(nodeId)}
        >
          <CopySharp className="inline size-5 text-white" />
        </BlockOutlineFloatingOptionButton>
      )}
    </BlockOutlineFloatingOptionsWrapper>
  );
}
